import { ProjectsSortField } from "@components/projects/projects-sort-types";
import { PROJECTS_TABLE_COLUMN_LABELS } from "@components/table/projects/projects-table-constants";
import { SortItem, SortOption } from "@custom-types/sort-types";
import { FaroCoreApiTypes } from "@stellar/core-api-client";

/** Default projects sort by option */
export const DEFAULT_PROJECTS_SORT_BY: FaroCoreApiTypes.ProjectsSortBy =
  "recently_modified_first";

/** Available projects sort field options */
export const PROJECTS_SORT_OPTIONS: Record<
  ProjectsSortField,
  SortOption<ProjectsSortField>
> = {
  name: {
    field: "name",
    label: PROJECTS_TABLE_COLUMN_LABELS.name,
  },
  lastUpdated: {
    field: "lastUpdated",
    label: PROJECTS_TABLE_COLUMN_LABELS.lastUpdated,
  },
  created: {
    field: "created",
    label: PROJECTS_TABLE_COLUMN_LABELS.created,
  },
  lastCaptured: {
    field: "lastCaptured",
    label: PROJECTS_TABLE_COLUMN_LABELS.lastCaptured,
  },
  size: {
    field: "size",
    label: PROJECTS_TABLE_COLUMN_LABELS.size,
  },
};

/** Map of the sort by options to the SortItem format */
export const PROJECTS_SORT_BY_MAP: Record<
  FaroCoreApiTypes.ProjectsSortBy,
  SortItem<ProjectsSortField>
> = {
  ["name_ascending"]: {
    field: "name",
    sort: "asc",
  },
  ["name_descending"]: {
    field: "name",
    sort: "desc",
  },
  ["recently_modified_first"]: {
    field: "lastUpdated",
    sort: "asc",
  },
  ["recently_modified_last"]: {
    field: "lastUpdated",
    sort: "desc",
  },
  ["storage_asc"]: {
    field: "size",
    sort: "asc",
  },
  ["storage_desc"]: {
    field: "size",
    sort: "desc",
  },
  ["last_captured_at_asc"]: {
    field: "lastCaptured",
    sort: "asc",
  },
  ["last_captured_at_desc"]: {
    field: "lastCaptured",
    sort: "desc",
  },
  ["created_at_asc"]: {
    field: "created",
    sort: "asc",
  },
  ["created_at_desc"]: {
    field: "created",
    sort: "desc",
  },
};
